import { render, staticRenderFns } from "./Government.vue?vue&type=template&id=4a484138&scoped=true&"
import script from "./Government.vue?vue&type=script&lang=js&"
export * from "./Government.vue?vue&type=script&lang=js&"
import style0 from "./Government.vue?vue&type=style&index=0&id=4a484138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a484138",
  null
  
)

export default component.exports